export default {
  introSteps: {
    exportFile: "Exportez le formulaire sans données depuis l'autre serveur Arena (par ex. Dev ou QA)",
    selectFile:
      'Sélectionnez le fichier exporté (.zip) : il est comparé avec ce formulaire et les différences sont affichées',
    applyChanges:
      'Vérifiez les différences et appliquez les modifications sélectionnées à ce formulaire (les suppressions ne sont jamais sélectionnées par défaut)',
    publish:
      'Les modifications sont enregistrées en brouillon : testez le formulaire et publiez-le pour les rendre effectives',
  },
  fileTooLarge:
    'Le fichier sélectionné est trop volumineux (max {{maxSize}} Mo) : exportez le formulaire sans données, les enregistrements et leurs fichiers ne sont pas nécessaires pour comparer des formulaires',
  selectNewSource: 'Sélectionner une nouvelle source',
  selectNewSourceInfo:
    'Abandonner cette comparaison et sélectionner un autre fichier de formulaire ou un autre formulaire',
  refreshComparison: 'Actualiser la comparaison',
  refreshComparisonInfo:
    "Comparer à nouveau le même fichier avec la version actuelle de ce formulaire (par ex. après l'avoir modifié)",
  sourceSurvey: 'Formulaire comparé : {{name}}',
  compareWithSurvey: 'Ou comparez avec un autre formulaire de ce serveur :',
  fingerprint: {
    thisSurvey: 'Ce formulaire',
    comparedSurvey: 'Formulaire comparé',
    equal: 'Identique à ce formulaire',
    different: 'Différente de ce formulaire',
    label: 'Empreinte',
    structural: 'structurelle',
    info: "Empreintes de la définition du formulaire (brouillon). Des empreintes égales signifient des définitions égales. La première inclut les identifiants internes : elle est égale uniquement pour des copies du même formulaire (par ex. exporté et importé sur un autre serveur). La structurelle utilise les noms et les codes : elle est égale aussi pour des formulaires créés séparément avec la même structure. Les noms, libellés, identifiants, dates et l'état de publication n'en font pas partie.",
    copy: "Copier l'empreinte complète : {{value}}",
    copied: 'Empreinte copiée dans le presse-papiers',
  },
  identical: 'Les formulaires sont identiques',
  counts:
    '{{added}} uniquement dans le formulaire comparé, {{changed}} modifiés, {{removed}} uniquement dans ce formulaire',
  surveyInfoChanged:
    "Les informations du formulaire (langues, cycles, libellés) sont différentes : voir l'onglet « Informations du formulaire »",
  onlyDifferences: 'Afficher uniquement les différences',
  hideLayoutOnly: 'Masquer les différences de mise en page uniquement',
  apply: 'Appliquer les modifications sélectionnées ({{count}})',
  applyConfirm: `Appliquer {{count}} modifications sélectionnées à ce formulaire ?
Les modifications sont enregistrées en brouillon : elles n'atteindront les enregistrements qu'à la publication du formulaire.`,
  willBeDeleted: 'sera supprimé',
  removedNodeDefInfo:
    "Cette définition de nœud n'existe que dans ce formulaire : appliquer cette modification la supprime (avec ses descendants) de ce formulaire.",
  removedItemInfo: 'Uniquement dans ce formulaire : appliquer cette modification le supprime de ce formulaire.',
  applyConfirmWithDeletionsHeader: 'Confirmer les suppressions',
  applyConfirmWithDeletions:
    "Appliquer {{count}} modifications sélectionnées à ce formulaire ?\n\n**{{deletionsCount}} d'entre elles suppriment des éléments de ce formulaire** (éléments absents du formulaire comparé) :\n\n{{- deletions}}\n\n$t(common.cantUndoWarning)",
  applyWithDeletions: 'Appliquer et supprimer',
  confirmSurveyName: 'Saisissez le nom de ce formulaire pour confirmer :',
  deletionOfItemsOf: 'éléments uniquement dans ce formulaire de **{{name}}**',
  moreDeletions: '... et {{count}} de plus',
  applyCompleted:
    'Modifications appliquées : {{applied}}, ignorées : {{skipped}}. Publiez le formulaire pour les rendre effectives.',
  tabs: {
    nodeDefs: 'Définitions de nœuds',
    categories: 'Catégories',
    taxonomies: 'Taxonomies',
    surveyInfo: 'Informations du formulaire',
    surveyFiles: 'Fichiers',
  },
  status: {
    added: 'Uniquement dans le formulaire comparé',
    changed: 'Modifié',
    removed: 'Uniquement dans ce formulaire',
  },
  statusLabel: 'État',
  matchedBy: {
    uuid: 'Associé par identifiant interne',
    name: 'Associé par nom (les identifiants internes sont différents)',
    manual: 'Associé manuellement : appliqué comme un renommage',
  },
  renameCandidate: "Il pourrait s'agir de « {{name}} » de ce formulaire, renommé",
  possibleRename: 'renommage possible',
  matchAsRename: 'Associer comme renommé',
  unmatch: "Annuler l'association",
  props: {
    branding: 'Image de marque',
    columnsNo: 'Colonnes',
    columnsOrder: 'Ordre des colonnes',
    cycles: 'Cycles',
    defaultCycleKey: 'Cycle par défaut',
    descriptions: 'Descriptions',
    extra: 'Propriétés supplémentaires',
    family: 'Famille',
    fieldManualLinks: 'Liens vers le manuel de terrain',
    formLayout: 'Mise en page du formulaire',
    genus: 'Genre',
    gridPosition: 'ligne {{row}}, colonne {{column}}, largeur {{width}}, hauteur {{height}}',
    itemExtraDef: 'Propriétés supplémentaires',
    keepNonApplicableValues: 'Conserver les valeurs non pertinentes',
    labels: 'Libellés',
    languages: 'Langues',
    layout: 'Mise en page',
    levels: 'Niveaux',
    messages: 'Messages',
    pagesOrder: 'Ordre des pages',
    parent: 'Entité parente',
    preloadedMapLayersEnabled: 'Couches de carte préchargées activées',
    reportingData: 'Données de rapport',
    sampleBasedImageInterpretationEnabled: "Interprétation d'images basée sur des échantillons",
    samplingPolygon: "Polygone d'échantillonnage",
    scientificName: 'Nom scientifique',
    size: 'Taille',
    srs: 'Systèmes de référence spatiale',
    surveyDocOptions: 'Options de la documentation du formulaire',
    userExtraPropDefs: "Propriétés supplémentaires de l'utilisateur",
    validations: 'Validations',
    vernacularLanguageCodes: 'Langues des noms vernaculaires',
    vernacularNames: 'Noms vernaculaires',
  },
  fileTypes: {
    preloadedMapLayer: 'Couche de carte préchargée',
    surveyDocImage: 'Image de la documentation du formulaire',
    brandingSurveyLogo1: 'Logo du formulaire 1',
    brandingSurveyLogo2: 'Logo du formulaire 2',
    brandingSurveyLogo3: 'Logo du formulaire 3',
    brandingLandingBackground: "Arrière-plan de la page d'accueil",
  },
  cycle: 'cycle {{cycle}}',
  property: 'Propriété',
  sourceValue: 'Formulaire comparé',
  targetValue: 'Ce formulaire',
  emptyValue: '(vide)',
  layoutOnly: 'mise en page uniquement',
  selectItem: 'Sélectionnez un élément pour voir les détails',
  noDifferences: 'Aucune différence',
  identicalItem: 'Aucune différence',
  dependsOn: 'Appliqué avec :',
  itemsCount: 'éléments : {{added}} ajoutés, {{changed}} modifiés, {{removed}} uniquement dans ce formulaire',
  itemCode: 'Code',
  taxaCount: 'taxons : {{added}} ajoutés, {{changed}} modifiés, {{removed}} uniquement dans ce formulaire',
  taxonCode: 'Code',
  changes: 'Modifications',
  moreItems: '... et {{count}} éléments de plus',
  categoryRemoval: 'Supprimer les éléments (et niveaux) présents uniquement dans ce formulaire',
  taxonomyRemoval: 'Supprimer les taxons et noms vernaculaires présents uniquement dans ce formulaire',
  removalSelected: 'suppression sélectionnée',
  publishedKept: '(publiés : conservés)',
  reasons: {
    categoryInUse: 'La catégorie est utilisée par des définitions de nœuds qui ne sont pas supprimées',
    categoryMissing: "La catégorie n'existe pas dans ce formulaire",
    cycleMissing: 'Un cycle est manquant dans ce formulaire',
    dependencyNotApplicable: 'Une modification dont elle dépend ne peut pas être appliquée',
    parentMissing: "La définition de nœud parente n'existe pas dans ce formulaire",
    publishedCategoryChanged: "La catégorie d'une définition de nœud publiée ne peut pas être modifiée",
    publishedKeyChanged: "La propriété « clé » d'une définition de nœud publiée ne peut pas être modifiée",
    publishedMoveNotSupported: 'Une définition de nœud publiée ne peut pas être déplacée vers une autre entité',
    publishedMultipleChanged: "La propriété « multiple » d'une définition de nœud publiée ne peut pas être modifiée",
    publishedTaxonomyChanged: "La taxonomie d'une définition de nœud publiée ne peut pas être modifiée",
    publishedTypeChanged: "Le type d'une définition de nœud publiée ne peut pas être modifié",
    taxonomyInUse: 'La taxonomie est utilisée par des définitions de nœuds qui ne sont pas supprimées',
    taxonomyMissing: "La taxonomie n'existe pas dans ce formulaire",
    nodeDefUsedByOthers:
      "D'autres définitions de nœuds l'utilisent dans leurs expressions : mettez-les également à jour",
    publishedCategoryItemsKept: 'Les éléments publiés ne peuvent pas être supprimés : ils sont conservés',
    publishedCategoryLevelsKept: 'Les niveaux publiés ne peuvent pas être supprimés : ils sont conservés',
    publishedCyclesRemoved:
      "Supprimer des cycles d'une définition de nœud publiée supprime ses données dans ces cycles",
    publishedLanguagesRemoved: 'Supprimer des langues supprime leurs libellés lors de la publication du formulaire',
    publishedNameChanged:
      "Renommage d'une définition de nœud publiée : les expressions utilisant l'ancien nom doivent être mises à jour",
    publishedNodeDefDeleted:
      'La définition de nœud est publiée : ses données seront supprimées lors de la publication du formulaire',
    publishedSurveyCyclesRemoved:
      'Supprimer des cycles supprime leurs enregistrements lors de la publication du formulaire',
    publishedTaxaKept: 'Les taxons publiés ne peuvent pas être supprimés : ils sont conservés',
    publishedVernacularNamesKept: 'Les noms vernaculaires publiés ne peuvent pas être supprimés : ils sont conservés',
  },
}
